import React from 'react';
import { Mode } from '@src/constants';
import PersonInList from '../../../../../objects/PersonInList';
import { AccordionWrapper } from 'react-lib/dist/components-es';
import { withTranslation } from 'react-i18next';
import PersonListContainer from '../../../../common/PersonListContainer';

type Props = {
  values: any;
  mode: Mode;
  validateOnChange: boolean;
  errors: any;
  setOverridePersonState: (arg: boolean) => void;
};

const IExposedPersonListContainer = ({
  values,
  mode,
  validateOnChange,
  errors,
  setOverridePersonState,
}: Props) => {
  const getContainerBody = () => {
    if (values.chemicalRiskAttributes.exposedPersons == null)
      values.chemicalRiskAttributes.exposedPersons = [];
    delete values.chemicalRiskAttributes.allExposedPersons;

    return (
      <PersonListContainer
        values={values}
        mode={mode}
        errors={errors}
        validateOnChange={validateOnChange}
        setOverridePersonState={setOverridePersonState}
        newPersonEntity={PersonInList}
        arrayPropName="chemicalRiskAttributes.exposedPersons"
        fieldPropName="person"
        showAddNew={true}
        showDeleteHandler={true}
        showEmailHandler={true}
        showNoEmailAvailable={true}
        sort={true}
        isExposedPesons={true}
      />
    );
  };
  return (
    <AccordionWrapper
      closable={false}
      accordionTitle="inventory.details.page.exposed.persons.list.container.title"
      render={getContainerBody}
      className=""
    />
  );
};

export default withTranslation()(IExposedPersonListContainer);
